import { Button, Heading, Text } from "@instacover/ui"
import { createFileRoute, Link } from "@tanstack/react-router"
import { Trans, useTranslation } from "react-i18next"

import { useStepWithMedia } from "@/services/dexie"

import { ImageLayout } from "../../../../components/layouts/ImageLayout"
import { useScreenTypeIntroText } from "../../../../locales/photoType"
import { LINKS } from "../../../../routing/links"
import { useFinishStepAndNavigate } from "../../../../routing/useStepsRouting"

export const Route = createFileRoute("/$sessionId/_session/damage/intro")({
  component: DamageIntro,
})

function DamageIntro() {
  const { t } = useTranslation()

  const { sessionId } = Route.useParams()
  const finishAndNavigate = useFinishStepAndNavigate(sessionId)

  const { data: step } = useStepWithMedia(sessionId, "Damage")
  const numberOfPhotos = step?.photosCount ?? 0

  const { title, text, primaryActionTitle } = useScreenTypeIntroText({ stepType: "Damage" })

  return (
    <ImageLayout
      dataTestId="damage-intro"
      iconName="Damage"
      content={
        <>
          <Heading as="h2" variant="h1">
            {title}
          </Heading>

          <div className="h-6 w-6 shrink-0" />

          <Text>
            <Trans
              defaults={text}
              components={{
                br: <br />,
                bold: <strong className="font-bold" />,
              }}
            />
          </Text>
        </>
      }
      footer={
        <>
          <div className="h-5 w-5 shrink-0" />

          <Link to={LINKS.damageNew(sessionId)}>
            <Button data-testid="damage-intro-photo-btn" as="span" className="w-full">
              {primaryActionTitle}
            </Button>
          </Link>

          {step?.canSkip && (
            <>
              <Button variant="secondary" onClick={() => finishAndNavigate("Damage")} className="mt-2">
                {numberOfPhotos > 0
                  ? t("damage.intro.secondaryActionTitleAlt")
                  : t("damage.intro.secondaryActionTitle")}
              </Button>
            </>
          )}

          <div className="h-11 w-11 shrink-0" />
        </>
      }
    />
  )
}
